import { render, staticRenderFns } from "./ProgressDiagram.vue?vue&type=template&id=89ba1718&scoped=true&"
import script from "./ProgressDiagram.vue?vue&type=script&lang=js&"
export * from "./ProgressDiagram.vue?vue&type=script&lang=js&"
import style0 from "./ProgressDiagram.vue?vue&type=style&index=0&id=89ba1718&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ba1718",
  null
  
)

export default component.exports